export const paymentsTypes = {
  FETCH_BILLS_START: 'FETCH_BILLS_START',
  VALIDATE_DISCOUNT_CODE_START: 'VALIDATE_DISCOUNT_CODE_START',
  MAKE_INVOICE_START: 'MAKE_INVOICE_START',
  MAKE_INVOICE_LOADING: 'MAKE_INVOICE_LOADING',
  MAKE_PAYMENT_WITHOUT_OFFICIAL_BILL_START:
    'MAKE_PAYMENT_WITHOUT_OFFICIAL_BILL_START',
  SAVE_PAYMENT_INFO_START: 'SAVE_PAYMENT_INFO_START',
  FETCH_PAYMENT_INFO_START: 'FETCH_PAYMENT_INFO_START',
  REDIRECT_TO_AUTO_UPGRADE_START: 'REDIRECT_TO_AUTO_UPGRADE_START',
  SET_BILLS: 'SET_BILLS',
  LOADING_BILLS: 'LOADING_BILLS',
  SET_DISCOUNT_CODE: 'SET_DISCOUNT_CODE',
  SET_SHOW_DISCOUNT_ERROR: 'SET_SHOW_DISCOUNT_ERROR',
  SET_PACKAGES: 'SET_PACKAGES',
  SET_PACKAGE_TYPES: 'SET_PACKAGE_TYPES',
  LOADING_PACKAGES: 'LOADING_PACKAGES',
  FETCH_PACKAGES_START: 'FETCH_PACKAGES_START',
  SET_SELECTED_PACKAGE: 'SET_SELECTED_PACKAGE',
  SET_SELECTED_PACKAGE_TYPE: 'SET_SELECTED_PACKAGE_TYPE',
  SET_SELECTED_DURATION: 'SET_SELECTED_DURATION',
  SET_IS_OFFICIAL_BILL_NEEDED: 'SET_IS_OFFICIAL_BILL_NEEDED',
  SET_USE_CREDIT: 'SET_USE_CREDIT',
  SET_INVOICE_ID: 'SET_INVOICE_ID',
  SET_SELECTED_CONVERSATION_COUNT: 'SET_SELECTED_CONVERSATION_COUNT',
  SET_PAYABLE_PRICE: 'SET_PAYABLE_PRICE',
  SET_IS_AUTO_UPGRADE_VISIBLE: 'SET_IS_AUTO_UPGRADE_VISIBLE',
  SET_IS_SELECT_BANK_VISIBLE: 'SET_IS_SELECT_BANK_VISIBLE',
  FETCH_PAYMENT_REPORT_START: 'FETCH_PAYMENT_REPORT_START',
  SET_SELECTED_BANK: 'SET_SELECTED_BANK',
  SET_SELECTED_UPGRADE_METHOD: 'SET_SELECTED_UPGRADE_METHOD',
  SET_PAYMENT_INFO: 'SET_PAYMENT_INFO',
  DISPLAY_INPUT_PAYMENT_INFO_MODAL: 'DISPLAY_INPUT_PAYMENT_INFO_MODAL',
  DISPLAY_SELECT_BANK_MODAL_START: 'DISPLAY_SELECT_BANK_MODAL_START',
  SET_USE_WHATSAPP_PACKAGES: 'SET_USE_WHATSAPP_PACKAGES',
  LOADIN_PAYMENT_INFO: 'LOADING_PAYMENT_INFO',
  UPDATE_IN_COMPLETE_USER_INFO_BY_MODAL:
    'UPDATE_IN_COMPLETE_USER_INFO_BY_MODAL',
  VALIDATE_SMS_AND_SAVE_USER_INFO: 'VALIDATE_SMS_AND_SAVE_USER_INFO',
  MAKE_INVOICE_WITHOUT_OFFICIAL_BILL_ENG:
    'MAKE_INVOICE_WITHOUT_OFFICIAL_BILL_ENG',
  FETCH_ENG_BILLS_START: 'FETCH_ENG_BILLS_START',
  CHECK_USER_INFORMATION: 'CHECK_USER_INFORMATION',
};
